import { render } from "./form-pilihan-ganda.vue?vue&type=template&id=bd210702"
import script from "./form-pilihan-ganda.vue?vue&type=script&lang=js"
export * from "./form-pilihan-ganda.vue?vue&type=script&lang=js"

import "./form-pilihan-ganda.vue?vue&type=style&index=0&id=bd210702&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__